// extracted by mini-css-extract-plugin
export default {"standingsTable":"Column_standingsTable__90h6H"};